/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Accept_BtnInputs */

const en_delivery_board_accept_btn = /** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept & Start Cooking`)
};

const es_delivery_board_accept_btn = /** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar y Empezar a Cocinar`)
};

const fr_delivery_board_accept_btn = /** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter et commencer à cuisiner`)
};

const de_delivery_board_accept_btn = /** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akzeptieren & Kochen starten`)
};

const id_delivery_board_accept_btn = /** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima & Mulai Memasak`)
};

/** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */
const ja_delivery_board_accept_btn = en_delivery_board_accept_btn;

/** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */
const zh_delivery_board_accept_btn = en_delivery_board_accept_btn;

/** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */
const ar_delivery_board_accept_btn = en_delivery_board_accept_btn;

/** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */
const it_delivery_board_accept_btn = en_delivery_board_accept_btn;

/** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */
const ru_delivery_board_accept_btn = en_delivery_board_accept_btn;

/** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */
const pt_delivery_board_accept_btn = en_delivery_board_accept_btn;

/** @type {(inputs: Delivery_Board_Accept_BtnInputs) => LocalizedString} */
const ko_delivery_board_accept_btn = en_delivery_board_accept_btn;

/**
* | output |
* | --- |
* | "Accept & Start Cooking" |
*
* @param {Delivery_Board_Accept_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_accept_btn = /** @type {((inputs?: Delivery_Board_Accept_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Accept_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_accept_btn(inputs)
	if (locale === "es") return es_delivery_board_accept_btn(inputs)
	if (locale === "fr") return fr_delivery_board_accept_btn(inputs)
	if (locale === "de") return de_delivery_board_accept_btn(inputs)
	if (locale === "ja") return ja_delivery_board_accept_btn(inputs)
	if (locale === "zh") return zh_delivery_board_accept_btn(inputs)
	if (locale === "ar") return ar_delivery_board_accept_btn(inputs)
	if (locale === "id") return id_delivery_board_accept_btn(inputs)
	if (locale === "it") return it_delivery_board_accept_btn(inputs)
	if (locale === "ru") return ru_delivery_board_accept_btn(inputs)
	if (locale === "pt") return pt_delivery_board_accept_btn(inputs)
	return ko_delivery_board_accept_btn(inputs)
});